import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Context menu action label that clears completed/failed uploads from the uploads list */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MenuClearUploadsButton.title?c=9hpiy7j4vwch", defaultMessage: "Clear Uploads" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
